import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=45ff5e50&scoped=true&"
import script from "./CreateList.vue?vue&type=script&lang=js&"
export * from "./CreateList.vue?vue&type=script&lang=js&"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=45ff5e50&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff5e50",
  null
  
)

export default component.exports